module.exports = __webpack_public_path__ + "img/kyoto-protocol.3b1a099d.jpg";